export default (state, { customerId }) => (
  state.userGroups
  && state.userGroups.data
  && state.userGroups.data[customerId]
  && state.userGroups.data[customerId].userGroups
) || {}
